<template>
  <div class="card card-stats card-raised">
    <div class="card-body">
      <div class="custom-statistics">
        <div v-for="card in statCards" class="info">
          <div :class="`icon info-icon icon-${card.iconStyle ?? 'primary'}`">
            <i :class="`now-ui-icons ${card.icon}`"></i>
          </div>
          <h3 class="info-value">
            <animated-number v-if="!card.money" :value="card.value" :percent="card?.percent"></animated-number>
            <animated-number-money v-else :value="card.value"></animated-number-money>
          </h3>
          <h6 class="info-title">{{ card.title }}</h6>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AnimatedNumber, AnimatedNumberMoney } from "src/components";

export default {
  name: "stats-group",
  props: {
    statCards: {
      type: Array,
      required: true,
    },
  },
  components: {
    AnimatedNumber,
    AnimatedNumberMoney,
  },
}
</script>
<style scoped lang="scss">
.custom-statistics {
  display: flex;
  flex-direction: row;
  justify-content: between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  // grid-gap: 1rem;

  .info {
    text-align: center;
    padding: .3rem;
    flex: 1;
    width: 100%;
    word-wrap: break-word;

    &:not(:first-child):not(:last-child) {
      border-left: 1px solid #e9ecef;
      border-right: 1px solid #e9ecef;
    }
  }

  .info-value {
    margin-bottom: .3rem;
  }
}

@media screen and (min-width: 601px) {
  .custom-statistics .info .info-value {
    font-size: 1.3rem !important;
    font-weight: 600 !important;
  }
  .custom-statistics .info .info-title {
    font-size: .7rem !important;
    font-weight: 400 !important;
  }
}

/* If the screen size is 600px wide or less, set the font-size of <div> to 30px */
@media screen and (max-width: 600px) {
  .custom-statistics .info .info-value {
    font-size: 5vw !important;
  }
  .custom-statistics .info .info-title {
    font-size: 4vw !important;
  }
}
</style>
